import _ from 'lodash'
import { createSelector } from 'reselect'

import { OrderItemStatusCode } from '../order'

import { RootState } from '../types'

const selectState = (state: RootState) => state.checkout

export const getCheckoutOrder = createSelector(selectState, state => state.order)

export const getCheckoutItems = createSelector(getCheckoutOrder, c => c.orderItems)

export const isCheckoutLoading = createSelector(selectState, state => state.loading)

export const getTotalCheckoutNetValueFormatted = createSelector(
  getCheckoutOrder,
  c => c.orderData?.totalNetValueFormatted
)

export const getTotalCheckoutValueWithTaxFormatted = createSelector(
  getCheckoutOrder,
  order => order.orderData?.totalValueWithTaxFormatted
)

export const getTotalCheckoutTaxValueFormatted = createSelector(
  getCheckoutOrder,
  order => order.orderData?.totalTaxValueFormatted
)

export const getPaymentError = createSelector(selectState, state => state.error)

export const getOrderIds = createSelector(selectState, state => state.customerRequestIds)

export const getCountries = createSelector(selectState, state => state.countries)

export const getStates = createSelector(selectState, state => state.states)

export const isAccountingError = createSelector(
  getCheckoutOrder,
  c =>
    c.orderData?.isAccountingError ||
    (!_.isEmpty(c.orderItems) && _.every(c.orderItems, i => i.statusCode === OrderItemStatusCode.Error))
)

export const isPaymentLoading = createSelector(selectState, x => x.loadingEntities['payment'] || false)

export const getPaymentOptions = createSelector(selectState, x => x.paymentOptions || [])

export const getCheckoutItemsCount = createSelector(getCheckoutOrder, state => state.orderItems.length || 0)

export const isAnyCustomerRequestErrorInCheckout = createSelector(
  getCheckoutOrder,
  state => state.orderData?.isAnyCustomerRequestError
)

export const getPayPerClick = createSelector(selectState, state => state.payPerClick)
